import { CurrentStep } from '../../constants/constants';

export const validateString = (value: unknown) => typeof value === 'string';
export const validateNumber = (value: unknown) => typeof value === 'number';

export const validateBoolean = (value: unknown) => typeof value === 'boolean';

export const addressValidate = (value: unknown) => {
  return typeof value === 'object';
};

export const validateAdditionalInterests = (value: unknown) => {
  return Array.isArray(value);
};

export const validateAdditionalInsuredRoommates = (value: unknown) => {
  return Array.isArray(value);
};

export const validateErrors = (value: unknown) => {
  return Array.isArray(value);
};

export const validateOptionalCoverages = (value: unknown) => {
  return typeof value === 'object';
};

export const validateUnit = (value: unknown) => {
  return typeof value === 'object';
};

export const validateCurrentStep = (value: CurrentStep) => {
  return (
    typeof value === 'string' && Object.values(CurrentStep).includes(value)
  );
};
